import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import styled from "styled-components";
import { isCompanyUser, useLoginContext } from "contexts/LoginContext/LoginContext";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import { Badge } from "antd";
import { BellOutlined } from "@ant-design/icons";
import axios from "axios";
import { StudentNotification } from "interfaces/students";
import LoginButtonKD from "./LoginButton/LoginButton_KD";
import ProfileButtonKD from "./ProfileButton/ProfileButton_KD";

interface UlProps {
  open: boolean;
  pathname: string;
}

const Ul = styled.ul<UlProps>`
  list-style: none;
  display: flex;
  flex-flow: row nowrap;
  white-space: nowrap;
  z-index: 140;
  li {
    line-height: 65px;
    padding: 0px 10px;
    color: ${props => (props.pathname === "/" ? "#f1f1f1" : "var(--font-color)")};
  }
  li a,
  li .ant-badge svg {
    color: ${props => (props.pathname === "/" ? "#f1f1f1" : "var(--font-color)")};
  }
  a:hover {
    font-weight: bold;
  }
  @media (max-width: 900px) {
    flex-flow: column nowrap;
    background-color: var(--primary-color);
    position: fixed;
    transform: ${({ open }) => (open ? "translateX(0)" : "translateX(100%)")};
    top: 0;
    right: 0;
    height: 100vh;
    width: 300px;
    padding-top: 3.5rem;
    transition: transform 0.3s ease-in-out;
    li {
      color: #fff;
      padding: 0px 40px 0 10px;
    }
    li a,
    li .ant-badge svg {
      color: #ffffff;
    }
  }
`;

interface Props {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

const RightNavKD: React.FC<Props> = ({ open, setOpen }) => {
  const [notificationCount, setNotificationCount] = useState(0);
  const { currentUser } = useLoginContext();
  const { pathname } = useLocation();

  document.querySelectorAll("li").forEach(el => el);

  const history = useHistory();

  const handleClick = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (!currentUser || isCompanyUser(currentUser)) return;
    axios
      .get<StudentNotification[]>("/students/student-notifications/")
      .then(response => setNotificationCount(response.data.filter(notification => !notification.read_at).length));
  }, [currentUser]);

  return (
    <Ul open={open} pathname={pathname}>
      <li>
        <NavLink to="/kd/events/" activeStyle={{ fontWeight: "bold" }} onClick={handleClick}>
          Arrangementer
        </NavLink>
      </li>
      <li>
        <NavLink to="/kd/jobs/" activeStyle={{ fontWeight: "bold" }} onClick={handleClick}>
          Stillingsannonser
        </NavLink>
      </li>
      <li>
        <NavLink to="/kd/about-us/" activeStyle={{ fontWeight: "bold" }} onClick={handleClick}>
          Om oss
        </NavLink>
      </li>
      <li>
        <NavLink to="/kd/contact-us/" activeStyle={{ fontWeight: "bold" }} onClick={handleClick}>
          Kontakt og informasjon
        </NavLink>
      </li>
      {currentUser ? (
        <>
          <li>
            <ProfileButtonKD setOpen={setOpen} />
          </li>
          {notificationCount > 0 ? (
            <li>
              <Badge count={notificationCount} dot>
                <BellOutlined
                  style={{ fontSize: "20px" }}
                  onClick={() => history.push("/student-profile/notifications/")}
                />
              </Badge>
            </li>
          ) : null}
        </>
      ) : (
        <li>
          <LoginButtonKD setOpen={setOpen} open={open} />
        </li>
      )}
    </Ul>
  );
};

export default RightNavKD;
